const spellingTimes = [
    [
        "",
        137.68115942028984
    ],
    [
        "“",
        837.68115942028984
    ],
    [
        "It",
        137.68115942028984
    ],
    [
        "seems",
        344.2028985507246
    ],
    [
        "like",
        275.3623188405797
    ],
    [
        "we’re",
        344.2028985507246
    ],
    [
        "on",
        137.68115942028984
    ],
    [
        "a",
        68.84057971014492
    ],
    [
        "path",
        275.3623188405797
    ],
    [
        "towards",
        481.8840579710145
    ],
    [
        "a",
        68.84057971014492
    ],
    [
        "kind",
        275.3623188405797
    ],
    [
        "of",
        537.68115942028984
    ],
    [
        "cultural",
        550.7246376811594
    ],
    [
        "fragmentation",
        1294.9275362318841
    ],
    [
        "that",
        275.3623188405797
    ],
    [
        "is",
        137.68115942028984
    ],
    [
        "unstoppable.",
        826.0869565217391
    ],
    [
        "There",
        344.2028985507246
    ],
    [
        "will",
        275.3623188405797
    ],
    [
        "be",
        137.68115942028984
    ],
    [
        "stories",
        581.8840579710145
    ],
    [
        "and",
        206.52173913043478
    ],
    [
        "forms",
        444.2028985507246
    ],
    [
        "of",
        137.68115942028984
    ],
    [
        "entertainment",
        894.9275362318841
    ],
    [
        "that",
        275.3623188405797
    ],
    [
        "may",
        406.52173913043478
    ],
    [
        "be",
        637.68115942028984
    ],
    [
        "in",
        337.68115942028984
    ],
    [
        "the",
        306.52173913043478
    ],
    [
        "English",
        481.8840579710145
    ],
    [
        "language",
        550.7246376811594
    ],
    [
        "but",
        206.52173913043478
    ],
    [
        "incomprehensible",
        1101.4492753623188
    ],
    [
        "across",
        413.04347826086956
    ],
    [
        "groups—a",
        550.7246376811594
    ],
    [
        "kind",
        275.3623188405797
    ],
    [
        "of",
        137.68115942028984
    ],
    [
        "‘inside",
        581.8840579710145
    ],
    [
        "speak.’",
        581.8840579710145
    ],
    [
        "That’s",
        413.04347826086956
    ],
    [
        "one",
        206.52173913043478
    ],
    [
        "possibility",
        757.2463768115941
    ],
    [
        "nine",
        275.3623188405797
    ],
    [
        "years",
        344.2028985507246
    ],
    [
        "out.”",
        275.3623188405797
    ],
    [
        "",
        "150"
    ]
];

export default spellingTimes;